import { ReactNode } from "react";
import styles from "./ContactInfo.module.scss";

interface ContactInfoProps {
  name: ReactNode;
  link: string;
  linkLabel: ReactNode;
}

const ContactInfo = ({ name, link, linkLabel }: ContactInfoProps) => (
  <div className={styles.container}>
    <span className={styles.label}>{name}</span>
    <span className={styles.value}>
      <a href={link}>{linkLabel}</a>
    </span>
  </div>
);

export default ContactInfo;
